import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../Pages/auth/authService';

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  const { user } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) => user
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
    />
  )
}


export default PrivateRoute;